import axios from 'axios';

export const loggedIn = () => {
  return axios.get("/loggedIn");
}
